import { AxiosResponse } from 'axios';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const responseInterceptor = (response: AxiosResponse) => {
    return response;
};